// import React from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import { getSubcategories, deleteSubcategory } from '../../../api/subcategory';
// import { Link, useNavigate } from 'react-router-dom';
// import {
//   Box,
//   Button,
//   VStack,
//   HStack,
//   Text,
//   Spinner,
//   Alert,
//   AlertIcon,
//   AlertTitle,
//   AlertDescription,
//   useToast,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalFooter,
//   ModalBody,
//   ModalCloseButton,
//   useDisclosure,
// } from '@chakra-ui/react';

// const SubcategoryList = () => {
//   const queryClient = useQueryClient();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const [selectedSubcategory, setSelectedSubcategory] = React.useState(null);

//   const { data: subcategories, error, isLoading } = useQuery('subcategories', getSubcategories);
// console.log(subcategories);
//   const deleteMutation = useMutation(deleteSubcategory, {
//     onSuccess: () => {
//       queryClient.invalidateQueries('subcategories');
//       toast({
//         title: 'Success',
//         description: 'Auctions deleted successfully',
//         status: 'success',
//         duration: 3000,
//         isClosable: true,
//       });
//       onClose();
//     },
//     onError: (error) => {
//       toast({
//         title: 'Error',
//         description: error.response?.data?.message || 'Failed to delete subcategory',
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//     },
//   });

//   const handleDelete = (subcategoryId) => {
//     setSelectedSubcategory(subcategoryId);
//     onOpen();
//   };

//   const confirmDelete = () => {
//     deleteMutation.mutate(selectedSubcategory);
//   };

//   if (isLoading) {
//     return (
//       <Box textAlign="center" py={10} px={6}>
//         <Spinner size="xl" />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box textAlign="center" py={10} px={6}>
//         <Alert status="error">
//           <AlertIcon />
//           <AlertTitle>Error:</AlertTitle>
//           <AlertDescription>{error.message}</AlertDescription>
//         </Alert>
//       </Box>
//     );
//   }

//   return (
//     <Box maxW="3xl" mx="auto" p={6} borderWidth={1} borderRadius="md" boxShadow="lg">
//       <HStack justify="space-between" mb={4}>
//         <Text fontSize="2xl" fontWeight="bold">Auctions</Text>
//         <Button colorScheme="blue" as={Link} to="/dashboard/admin/subcategories/new">
//           Add New Auctions
//         </Button>
//       </HStack>
//       <VStack spacing={4} align="stretch">
//         {subcategories?.data?.map((subcategory) => (
//           <Box
//             key={subcategory?.subcategory?._id}
//             p={4}
//             borderWidth={1}
//             borderRadius="md"
//             boxShadow="md"
//             _hover={{ boxShadow: 'lg' }}
//           >
//             <HStack justify="space-between">
//               <Text fontSize="lg">{subcategory?.subcategory?.name}</Text>
//               <HStack spacing={2}>
//                 <Button colorScheme="teal" as={Link} to={`/dashboard/admin/subcategories/${subcategory?.subcategory?._id}/edit`}>
//                   Edit
//                 </Button>
//                 <Button colorScheme="red" onClick={() => handleDelete(subcategory._id)}>
//                   Delete
//                 </Button>
//               </HStack>
//             </HStack>
//           </Box>
//         ))}
//       </VStack>

//       <Modal isOpen={isOpen} onClose={onClose}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Confirm Delete</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             Are you sure you want to delete this subcategory? This action cannot be undone.
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme="red" onClick={confirmDelete} isLoading={deleteMutation.isLoading}>
//               Delete
//             </Button>
//             <Button variant="ghost" onClick={onClose} ml={3}>
//               Cancel
//             </Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// };

// export default SubcategoryList;








import React from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { getSubcategories, deleteSubcategory } from '../../../api/subcategory';
import { Link, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  VStack,
  HStack,
  Text,
  Spinner,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react';

const SubcategoryList = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedSubcategory, setSelectedSubcategory] = React.useState(null);

  const { data: subcategories, error, isLoading } = useQuery('subcategories', getSubcategories);
  console.log(subcategories);

  const deleteMutation = useMutation(deleteSubcategory, {
    onSuccess: () => {
      queryClient.invalidateQueries('subcategories');
      toast({
        title: 'Success',
        description: 'Auctions deleted successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onClose();
    },
    onError: (error) => {
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Failed to delete subcategory',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    },
  });

  const handleDelete = (subcategoryId) => {
    setSelectedSubcategory(subcategoryId);
    onOpen();
  };

  const confirmDelete = () => {
    deleteMutation.mutate(selectedSubcategory);
  };

  const handleCopyURL = (subcategoryId) => {
    const url = `${window.location.origin}/auction/${subcategoryId}`;
    navigator.clipboard.writeText(url);
    toast({
      title: 'URL Copied',
      description: 'The auction URL has been copied to your clipboard.',
      status: 'info',
      duration: 3000,
      isClosable: true,
    });
  };

  if (isLoading) {
    return (
      <Box textAlign="center" py={10} px={6}>
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box textAlign="center" py={10} px={6}>
        <Alert status="error">
          <AlertIcon />
          <AlertTitle>Error:</AlertTitle>
          <AlertDescription>{error.message}</AlertDescription>
        </Alert>
      </Box>
    );
  }

  return (
    <Box maxW="3xl" mx="auto" p={6} borderWidth={1} borderRadius="md" boxShadow="lg">
      <HStack justify="space-between" mb={4}>
        <Text fontSize="2xl" fontWeight="bold">Auctions</Text>
        <Button colorScheme="blue" as={Link} to="/dashboard/admin/subcategories/new">
          Add New Auctions
        </Button>
      </HStack>
      <VStack spacing={4} align="stretch">
        {subcategories?.data?.map((subcategory) => (
          <Box
            key={subcategory?.subcategory?._id}
            p={4}
            borderWidth={1}
            borderRadius="md"
            boxShadow="md"
            _hover={{ boxShadow: 'lg' }}
          >
            <HStack justify="space-between">
              <Text fontSize="lg">{subcategory?.subcategory?.name}</Text>
              <HStack spacing={2}>
                <Button colorScheme="teal" as={Link} to={`/dashboard/admin/subcategories/${subcategory?.subcategory?._id}/edit`}>
                  Edit
                </Button>
                <Button colorScheme="red" onClick={() => handleDelete(subcategory._id)}>
                  Delete
                </Button>
                <Button colorScheme="blue" onClick={() => handleCopyURL(subcategory?.subcategory?._id)}>
                  Copy URL
                </Button>
                <Button colorScheme="green" as={Link} to={`/auction/${subcategory?.subcategory?._id}`}>
                  Watch Auction
                </Button>
              </HStack>
            </HStack>
          </Box>
        ))}
      </VStack>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Delete</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure you want to delete this subcategory? This action cannot be undone.
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={confirmDelete} isLoading={deleteMutation.isLoading}>
              Delete
            </Button>
            <Button variant="ghost" onClick={onClose} ml={3}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default SubcategoryList;















